const youTubeEmbed = (url) => {
  return `https://www.youtube.com/embed/${url.substring(
    32,
    43
  )}?controls=0&rel=0`;
};

export default youTubeEmbed;
